import { Pictogram } from '@eti/components';
import { useDirection, useSiteContext, useTranslation } from '@eti/providers';
import { css } from '@eti/styles';
import { Link } from 'react-router-dom';
import { Button, Inline } from '@etg/wings';
import { FAST_TRACK, getProductPictogramId, productIds } from '@eti/products';
import Banner from '../../../../common/components/Banner';
import { routes } from '../../../../constants/routesAndApisConstants';

const pictogramStyles = css`
  margin: 16px;
`;

const buttonStyles = css`
  width: 100%;
`;

const FastTrackBanner = () => {
  const { t } = useTranslation();
  const { brand } = useSiteContext();
  const { isRTL } = useDirection();

  return (
    <Banner
      data-testid="fast-track"
      description={t('OrderDetails.Banner.FastTrack.Description')}
      footer={
        <Inline align="end" alignY="center" className={buttonStyles}>
          <Button
            as={Link}
            data-testid="fast-track-link"
            to={`${routes.ORDER_DETAILS_EXTRA_PRODUCTS}#product-id-${FAST_TRACK.id}`}
            variant="secondary"
          >
            {t('OrderDetails.Banner.FastTrack.Button.Text')}
          </Button>
        </Inline>
      }
      icon={
        <Pictogram
          brand={brand.code}
          className={pictogramStyles}
          data-testid="fast-track-icon"
          id={getProductPictogramId(productIds[Number(FAST_TRACK.id)], isRTL)}
          size="4rem"
        />
      }
      title={t('OrderDetails.Banner.FastTrack.Title')}
    />
  );
};

export default FastTrackBanner;
